import Swal from 'sweetalert2';

export function showSwalNotification(response = {}) {
  const {
    status = 'error',
    message = 'An unexpected error occurred.',
  } = response;

  const normalizedStatus = status.toLowerCase();

  const isSuccess = ['success', 'created', 'no content'].includes(normalizedStatus);
  const isWarning = ['unauthorized', 'forbidden', 'bad request', 'too many requests', 'payment required'].includes(normalizedStatus);

  const icon = isSuccess ? 'success' : isWarning ? 'warning' : 'error';
  const position = isSuccess ? 'top-end' : isWarning ? 'top' : 'center';
  const background = isSuccess
    ? '#1f7a1f'
    : isWarning
      ? '#ff8c00'
      : '#8b0000';

  Swal.fire({
    icon,
    title: capitalize(normalizedStatus),
    text: message,
    position,
    toast: isSuccess,
    showConfirmButton: !isSuccess,
    confirmButtonText: 'Dismiss',
    timer: isSuccess ? 6000 : undefined,
    timerProgressBar: isSuccess,
    background,
    color: '#fdf5e6',
    didOpen: () => {
      const popup = document.querySelector('.swal2-popup');
      const title = document.querySelector('.swal2-title');
      const button = document.querySelector('.swal2-confirm');

      if (popup) {
        popup.style.borderRadius = '16px';
        popup.style.boxShadow = '0 0 15px rgba(0, 0, 0, 0.25)';
        popup.style.fontFamily = "'Segoe UI', 'Helvetica Neue', sans-serif";
      }

      if (title) {
        title.style.fontSize = '1.3rem';
        title.style.fontWeight = '600';
        title.style.textTransform = 'capitalize';
      }

      if (button) {
        button.style.backgroundColor = '#333';
        button.style.color = '#fdf5e6';
        button.style.borderRadius = '8px';
        button.style.padding = '6px 16px';
        button.style.fontWeight = '500';
        button.style.transition = 'background-color 0.3s ease';
        button.onmouseover = () => (button.style.backgroundColor = '#222');
        button.onmouseout = () => (button.style.backgroundColor = '#333');
      }
    }
  });
}

function capitalize(text) {
  return text?.charAt(0).toUpperCase() + text?.slice(1);
}